"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListsAPI = void 0;
const base_1 = require("../base");
class ListsAPI extends base_1.BaseAPI {
    /**
     * Get the details of a list.
     *
     * @see https://developers.themoviedb.org/3/lists/get-list-details
     */
    async details(listId, filters) {
        const path = this.getPath(`/list/${listId}`, filters);
        return this.get(path);
    }
    /**
     * You can use this method to check if a movie has already been added to the list.
     *
     * @see https://developers.themoviedb.org/3/lists/check-item-status
     */
    async itemStatus(listId, filters) {
        const path = this.getPath(`/list/${listId}/item_status`, filters);
        return this.get(path);
    }
    /**
     * Create a list.
     *
     * @see https://developers.themoviedb.org/3/lists/create-list
     */
    async create(data, filters) {
        const path = this.getPath('/list', filters);
        return this.post(path, data);
    }
    /**
     * Add movie to a list.
     *
     * @see https://developers.themoviedb.org/3/lists/add-movie
     */
    async addItem(listId, data, filters) {
        const path = this.getPath(`/list/${listId}/add_item`, filters);
        return this.post(path, data);
    }
    /**
     * Remove a movie from a list.
     *
     * @see https://developers.themoviedb.org/3/lists/remove-movie
     */
    async removeItem(listId, data, filters) {
        const path = this.getPath(`/list/${listId}/remove_item`, filters);
        return this.post(path, data);
    }
    /**
     * Clear all of the items from a list.
     *
     * @see https://developers.themoviedb.org/3/lists/clear-list
     */
    async clear(listId, filters) {
        const path = this.getPath(`/list/${listId}/clear`, filters);
        return this.post(path);
    }
    /**
     * Delete a list.
     *
     * @see https://developers.themoviedb.org/3/lists/delete-list
     */
    async remove(listId, filters) {
        const path = this.getPath(`/list/${listId}`, filters);
        return this.delete(path);
    }
}
exports.ListsAPI = ListsAPI;
